import type { Ref } from 'vue';
import { ref } from 'vue';

import type { IAffiliateProgramCreativesListItem } from '@modules/affiliate-program-creatives/types';

export interface AffiliateProgramCreativePreviewComposable {
  previewCreative: Ref<IAffiliateProgramCreativesListItem | undefined>;
  onPreview(creative: IAffiliateProgramCreativesListItem): void;
  onPreviewHide(): void;
}

export default function useAffiliateProgramCreativePreview(): AffiliateProgramCreativePreviewComposable {
  const previewCreative = ref<IAffiliateProgramCreativesListItem>();

  function onPreview(creative: IAffiliateProgramCreativesListItem): void {
    previewCreative.value = creative;
  }

  function onPreviewHide(): void {
    previewCreative.value = undefined;
  }

  return {
    previewCreative,
    onPreview,
    onPreviewHide,
  };
}
